import { useNavigate } from 'react-router'

import Button from '@/components/button'

import { useStyles } from './styles'

export function ErrorComponent() {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <div className={classes.main}>
      <span>Não foi possível carregar as informações.</span>
      <Button labelOnly onClick={() => navigate(0)}>
        RECARREGAR PÁGINA
      </Button>
    </div>
  )
}
